import Button from "@material-ui/core/Button";
import React from "react";
import { createUseStyles } from "react-jss";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = createUseStyles({
  toolbar: {
    marginRight: "20px",
    marginLeft: "20px",
    position: "static",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    height: "50px",
  },
  headline: {
    fontSize: "18px",
    fontWeight: "700",
    lineHeight: "24px",
  },
  statusIcon: {
    width: "8px",
    height: "8px",
    left: "38px",
    top: "30px",
    borderRadius: "50%",
    marginRight: "5px",
  },
  statusWrapper: {
    display: "flex",
    alignItems: "center",
  },
  status: {
    boxSizing: "border-box",
    fontSize: "16px",
    fontWeight: "700",
    marginRight: "15px",
  },
  online: {
    color: "#01998C",
  },
  offline: {
    color: "#717171",
  },
  onlineIcon: {
    background: "#01998C",
  },
  offlineIcon: {
    background: "#717171",
  },
});

const materialUiStyles = makeStyles({
  manuButton: {
    textTransform: "none",
    textDecoration: "underline",
    boxSizing: "border-box",
  },
});

export default ({ onSetAgentStatus, agentOnlineStatus }) => {
  const styles = useStyles();
  const materialStyles = materialUiStyles();

  return (
    <div className={styles.toolbar}>
      <p className={styles.headline}>Hyro Handoff Conversations</p>
      <div className={styles.statusWrapper}>
        <div
          className={[
            styles.statusIcon,
            agentOnlineStatus ? styles.onlineIcon : styles.offlineIcon,
          ].join(" ")}
        ></div>
        <div
          className={[
            styles.status,
            agentOnlineStatus ? styles.online : styles.offline,
          ].join(" ")}
        >
          {agentOnlineStatus ? "Online" : "Offline"}
        </div>
        <Button
          size="small"
          className={materialStyles.manuButton}
          onClick={() => onSetAgentStatus()}
        >
          {agentOnlineStatus ? "Switch to offline" : "Switch to online"}
        </Button>
      </div>
    </div>
  );
};
